(() => {
  const selector = "[data-gameday-immersive-model]";

  const wireViewer = (root) => {
    if (!root || root.dataset.gamedayImmersiveReady === "true") return;

    const viewer = root.querySelector("model-viewer");
    const status = root.querySelector(".gameday-immersive-model__status");
    if (!viewer) return;

    root.dataset.gamedayImmersiveReady = "true";
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) {
      viewer.removeAttribute("auto-rotate");
    }

    const markLoaded = () => {
      root.classList.add("is-model-ready");
      root.classList.remove("has-model-error");
      if (status) status.textContent = "Interactive 3D model ready. Drag to rotate and scroll or pinch to zoom.";
      viewer.dispatchEvent(new CustomEvent("exo:model-viewer-ready"));
    };

    const markError = () => {
      root.classList.add("has-model-error");
      root.classList.remove("is-model-ready");
      if (status) status.textContent = "Interactive 3D is unavailable. The verified product image remains visible.";
    };

    viewer.addEventListener("load", markLoaded, { once: true });
    viewer.addEventListener("error", markError);

    if (viewer.loaded || viewer.modelIsVisible) markLoaded();
  };

  const wireAll = () => document.querySelectorAll(selector).forEach(wireViewer);

  const markAllUnavailable = () => {
    document.querySelectorAll(selector).forEach((root) => {
      root.classList.add("has-model-error");
      const status = root.querySelector(".gameday-immersive-model__status");
      if (status) status.textContent = "Interactive 3D is unavailable. The verified product image remains visible.";
    });
  };

  const loadModelViewer = async () => {
    if (window.customElements?.get("model-viewer")) {
      wireAll();
      return;
    }

    if (!window.customElements?.whenDefined) {
      markAllUnavailable();
      return;
    }

    const registered = await Promise.race([
      window.customElements.whenDefined("model-viewer").then(() => true),
      new Promise((resolve) => window.setTimeout(() => resolve(false), 12000)),
    ]);

    if (registered) wireAll();
    else markAllUnavailable();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", loadModelViewer, { once: true });
  } else {
    loadModelViewer();
  }

  document.addEventListener("shopify:section:load", wireAll);
})();
